import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=683b6afc&"
import script from "./Stats.vue?vue&type=script&lang=js&"
export * from "./Stats.vue?vue&type=script&lang=js&"
import style0 from "./Stats.vue?vue&type=style&index=0&id=683b6afc&prod&lang=scss&"
import style1 from "./Stats.vue?vue&type=style&index=1&id=683b6afc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports